module.exports = __webpack_public_path__ + "static/img/1.b06b01f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/1.png
// module id = /R43
// module chunks = 0